module.exports = __webpack_public_path__ + "static/media/avatar.c928a4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/mitarbeiter/avatar.png
// module id = 109
// module chunks = 0